import { render, staticRenderFns } from "./PageListAddNew.vue?vue&type=template&id=a5ef3c98&"
import script from "./PageListAddNew.vue?vue&type=script&lang=js&"
export * from "./PageListAddNew.vue?vue&type=script&lang=js&"
import style0 from "./PageListAddNew.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports